import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@hweeks/kei-costs-ui-testids';
import { CtaBand } from './CtaBand';
import { Spot, StampedSheet } from './illustrations';
import { MKT } from './links';
import { MarketingLayout } from './MarketingLayout';
import { NextLink, ProductDetails, ProductFaq, ProductHero, ProductSection } from './ProductParts';
import './product-sheets.css';
// Product · 02 Auction sheets. Built from design-mockups/rhd-woodblock/Product-Auction-Sheets.dc.html.
// The sheet and its read are an illustrative example (lot 41207, the Stagea used across the site).
export default function ProductSheetsPage() {
    return /*#__PURE__*/ _jsx(MarketingLayout, {
        testid: Testids.app.marketing.productRoot('auction-sheets'),
        children: /*#__PURE__*/ _jsxs("main", {
            children: [
                /*#__PURE__*/ _jsx(ProductHero, {
                    stack: true,
                    k: "査定",
                    label: "Product · 02 Auction sheets",
                    title: "Every auction sheet, read in plain English.",
                    lead: "You see the original Japanese sheet with a structured read next to it, covering grades, mileage, damage, options, the inspector’s notes and the full frame number.",
                    copyStyle: {
                        maxWidth: 800
                    },
                    leadStyle: {
                        maxWidth: 640
                    },
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "mk-product-sheets__sheets-hero-div-3",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mk-product-sheets__sheets-hero-div-4",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-product-sheets__sheets-hero-div-5",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                children: "出品票 · 原本"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "mk-product-sheets__sheets-hero-span",
                                                children: "41207"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-product-sheets__sheets-hero-div-6",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mk-product-sheets__sheets-hero-div-7",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-8",
                                                        children: "車名"
                                                    }),
                                                    "ステージア"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mk-product-sheets__sheets-hero-div-7",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-8",
                                                        children: "年式"
                                                    }),
                                                    "H11"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mk-product-sheets__sheets-hero-div-7",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-8",
                                                        children: "型式"
                                                    }),
                                                    "WGNC34"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mk-product-sheets__sheets-hero-div-9",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-8",
                                                        children: "評価点"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-product-sheets__sheets-hero-span-2",
                                                        children: "3.5"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mk-product-sheets__sheets-hero-div-7",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-8",
                                                        children: "走行"
                                                    }),
                                                    "98千km"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mk-product-sheets__sheets-hero-div-7",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-8",
                                                        children: "シフト"
                                                    }),
                                                    "AT · 4WD"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mk-product-sheets__sheets-hero-div-7",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-8",
                                                        children: "内装"
                                                    }),
                                                    "B"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mk-product-sheets__sheets-hero-div-7",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-8",
                                                        children: "外装"
                                                    }),
                                                    "C"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mk-product-sheets__sheets-hero-div-10",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-product-sheets__sheets-hero-div-8",
                                                        children: "車台番号 "
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-product-sheets__sheets-hero-span-3",
                                                        children: "WGNC34-012345"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-product-sheets__sheets-hero-div-11",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mk-product-sheets__sheets-hero-div-12",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-13"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-14"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-product-sheets__sheets-hero-span-4",
                                                        children: "U2"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-product-sheets__sheets-hero-span-5",
                                                        children: "A1"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-product-sheets__sheets-hero-span-6",
                                                        children: "A2"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-product-sheets__sheets-hero-span-7",
                                                        children: "W1"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mk-product-sheets__sheets-hero-div-15",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-8",
                                                        children: "検査員報告"
                                                    }),
                                                    "左Fフェンダー凹み",
                                                    /*#__PURE__*/ _jsx("br", {}),
                                                    "屋根小キズ",
                                                    /*#__PURE__*/ _jsx("br", {}),
                                                    "下廻りサビ少",
                                                    /*#__PURE__*/ _jsx("br", {}),
                                                    "内装ヤレ少"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mk-product-sheets__sheets-hero-div-16",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-product-sheets__sheets-hero-div-17",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                children: "English read"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "mk-product-sheets__sheets-hero-span-8",
                                                children: "Lot 41207"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-product-sheets__sheets-hero-div-18",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-19",
                                                        children: "Vehicle"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-20",
                                                        children: "1999 Nissan Stagea RS Four V"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-19",
                                                        children: "Overall grade"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-21",
                                                        children: "3.5"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-19",
                                                        children: "Int / Ext"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-22",
                                                        children: "B / C"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-19",
                                                        children: "Mileage"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-22",
                                                        children: "98,000 km"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-19",
                                                        children: "Drive"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-22",
                                                        children: "AT · 4WD · Turbo"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-19",
                                                        children: "Model year"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-product-sheets__sheets-hero-div-22",
                                                        children: "H11 = 1999"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-product-sheets__sheets-hero-div-23",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "mk-product-sheets__sheets-hero-div-24",
                                                children: "Frame number"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "mk-product-sheets__sheets-hero-span-9",
                                                children: "WGNC34-012345"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-product-sheets__sheets-hero-div-25",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "mk-product-sheets__sheets-hero-div-19",
                                                children: "Damage map"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("b", {
                                                        className: "mk-product-sheets__sheets-hero-b",
                                                        children: "U2"
                                                    }),
                                                    " Dent, left front fender"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("b", {
                                                        className: "mk-product-sheets__sheets-hero-b",
                                                        children: "W1"
                                                    }),
                                                    " Minor repair wave, right front"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("b", {
                                                        className: "mk-product-sheets__sheets-hero-b",
                                                        children: "A1"
                                                    }),
                                                    " Small scratch, roof"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("b", {
                                                        className: "mk-product-sheets__sheets-hero-b",
                                                        children: "A2"
                                                    }),
                                                    " Scratch, rear bumper"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "mk-product-sheets__sheets-hero-div-26",
                                                children: "Inspector: “Dent LF fender. Small scratch on roof. Light underbody rust. Minor interior wear.”"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Spot, {
                    width: 260,
                    children: /*#__PURE__*/ _jsx(StampedSheet, {})
                }),
                /*#__PURE__*/ _jsxs(ProductSection, {
                    label: "A sheet, walked through",
                    title: "What it reads, box by box.",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "mk-product-sheets__how-it-works-div",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "mk-product-sheets__how-it-works-div-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "mk-product-sheets__how-it-works-span",
                                            children: "1"
                                        }),
                                        /*#__PURE__*/ _jsx("h3", {
                                            className: "mk-product-sheets__how-it-works-h3",
                                            children: "Grade box"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "mk-product-sheets__how-it-works-p",
                                            children: "The overall grade comes first (S, 6–1, or R/RA for repaired), then the interior and exterior letters from A to E."
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-product-sheets__how-it-works-div-3",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-sheets__how-it-works-span-2",
                                                    children: "3.5"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-sheets__how-it-works-span-3",
                                                    children: "B"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-sheets__how-it-works-span-3",
                                                    children: "C"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "mk-product-sheets__how-it-works-div-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "mk-product-sheets__how-it-works-span",
                                            children: "2"
                                        }),
                                        /*#__PURE__*/ _jsx("h3", {
                                            className: "mk-product-sheets__how-it-works-h3",
                                            children: "Damage map codes"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "mk-product-sheets__how-it-works-p",
                                            children: "The letter tells you the kind of damage and the number tells you the size. Each code goes on the panel where the inspector marked it."
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-product-sheets__how-it-works-div-4",
                                            children: [
                                                /*#__PURE__*/ _jsx("b", {
                                                    className: "mk-product-sheets__how-it-works-b",
                                                    children: "A"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "Scratch"
                                                }),
                                                /*#__PURE__*/ _jsx("b", {
                                                    className: "mk-product-sheets__how-it-works-b",
                                                    children: "U"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "Dent"
                                                }),
                                                /*#__PURE__*/ _jsx("b", {
                                                    className: "mk-product-sheets__how-it-works-b",
                                                    children: "W"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "Repair wave"
                                                }),
                                                /*#__PURE__*/ _jsx("b", {
                                                    className: "mk-product-sheets__how-it-works-b",
                                                    children: "S · C"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "Rust · corrosion"
                                                }),
                                                /*#__PURE__*/ _jsx("b", {
                                                    className: "mk-product-sheets__how-it-works-b",
                                                    children: "X · XX"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "Needs replacing · replaced"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "mk-product-sheets__how-it-works-div-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "mk-product-sheets__how-it-works-span",
                                            children: "3"
                                        }),
                                        /*#__PURE__*/ _jsx("h3", {
                                            className: "mk-product-sheets__how-it-works-h3",
                                            children: "Inspector notes"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "mk-product-sheets__how-it-works-p",
                                            children: "The handwritten comments, translated line by line. This is often the part that changes your bid."
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-product-sheets__how-it-works-div-5",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-sheets__how-it-works-span-4",
                                                    children: "左Fフェンダー凹み"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "Dent, LF fender"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-sheets__how-it-works-span-4",
                                                    children: "下廻りサビ少"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "Light rust underbody"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "mk-product-sheets__how-it-works-div-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "mk-product-sheets__how-it-works-span",
                                            children: "4"
                                        }),
                                        /*#__PURE__*/ _jsx("h3", {
                                            className: "mk-product-sheets__how-it-works-h3",
                                            children: "Frame number"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "mk-product-sheets__how-it-works-p",
                                            children: "The full chassis number. A JDM car doesn’t have a 17-digit VIN. This number follows the car into your paperwork and onto the title."
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "mk-product-sheets__how-it-works-span-5",
                                            children: "WGNC34-012345"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "mk-product-sheets__how-it-works-div-6",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "mk-product-sheets__how-it-works-div-7",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "mk-product-sheets__how-it-works-span-6",
                                            children: "訂正"
                                        }),
                                        /*#__PURE__*/ _jsx("h3", {
                                            className: "mk-product-sheets__how-it-works-h3-2",
                                            children: "Fix a misread once"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "mk-product-sheets__how-it-works-p-2",
                                            children: "The sheet stays next to the read so you can check any field. When the reader isn’t sure of a frame number, it flags it. Correct it on the car and the fix stays with that car."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "mk-product-sheets__how-it-works-div-8",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-product-sheets__how-it-works-div-9",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-sheets__how-it-works-span-7",
                                                    children: "Frame number"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-sheets__how-it-works-span-8",
                                                    children: "Check this · handwriting unclear"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-product-sheets__how-it-works-div-10",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-sheets__how-it-works-span-9",
                                                    children: "WGNC34-012845"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "→"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-sheets__how-it-works-span-10",
                                                    children: "WGNC34-012345"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-sheets__how-it-works-span-11",
                                                    children: "✓ Corrected by you"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(ProductDetails, {
                    title: "What gets pulled out of every sheet",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "mk-product-sheets__details-div-2",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "mk-product-sheets__details-div-3",
                                children: "Overall, interior, exterior grade"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "mk-product-sheets__details-div-3",
                                children: "Mileage, in km or miles as written"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "mk-product-sheets__details-div-3",
                                children: "Model year (Japanese era → Western)"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "mk-product-sheets__details-div-3",
                                children: "Make, model and full frame number"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "mk-product-sheets__details-div-3",
                                children: "Transmission, drive and AC"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "mk-product-sheets__details-div-3",
                                children: "Damage marks and repair history"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "mk-product-sheets__details-div-3",
                                children: "Inspector comments and red flags"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "mk-product-sheets__details-div-3",
                                children: "Options and equipment"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(ProductFaq, {
                    title: "Sheet questions",
                    items: [
                        [
                            'What if the lot has no sheet yet?',
                            'A hunt can email your agent and ask for it. With Fastmail connected, the app picks up the reply and reads the sheet by itself.'
                        ],
                        [
                            'How accurate is the translation?',
                            'Printed fields read reliably. Handwriting is harder, so keep the original beside the read and check anything that would change your bid.'
                        ],
                        [
                            'Can I upload a sheet I got elsewhere?',
                            'Yes. Upload a photo or scan of it on the car, or on the lot in a hunt.'
                        ]
                    ]
                }),
                /*#__PURE__*/ _jsx(NextLink, {
                    label: "Next · 03",
                    title: "Pricing guidance",
                    go: "相場 →",
                    href: MKT.product('pricing-guidance')
                }),
                /*#__PURE__*/ _jsx(CtaBand, {})
            ]
        })
    });
}
